/* prettier-ignore */
/** @see {@link https://developer.mozilla.org/en-US/docs/Glossary/Null} Null */
export const SAMPLE_NULLS = [
	// eslint-disable-next-line unicorn/no-null
	null,
] as const;
